import { createReportSurfaceTheme } from '../shared/report-design';
import { createTheme, darken, getContrastRatio, lighten } from '@mui/material/styles';

// Surfaces and controls inherit semantic tokens from the app's client brand and mode.
// Chart marks need contrast against the surface even for pale saved brand colors.
export const createRestaurantTheme = brandTheme => {
    const base = brandTheme.palette.mode === 'dark' ? brandTheme : createReportSurfaceTheme(brandTheme);
    const dataColor = color => getContrastRatio(color, base.palette.background.paper) >= 3 ? color
        : base.palette.mode === 'dark' ? lighten(color, 0.65) : darken(color, 0.65);
    return createTheme({
        ...base,
        restaurant: { activity: dataColor(base.palette.primary.main), revenue: dataColor(base.palette.secondary.main) },
        components: {
            ...base.components,
            MuiTableCell: { ...base.components?.MuiTableCell, styleOverrides: { ...base.components?.MuiTableCell?.styleOverrides,
                head: { backgroundColor: base.palette.background.default, color: base.palette.text.primary },
                body: { color: base.palette.text.primary, borderColor: base.palette.divider }
            } }
        }
    });
};
